<template>
  <section>
    <h2 class="hdg_order01"><i></i>出荷先変換マスタ</h2>
    <table class="table table-bordered bg-white tbl_master01" data-scoped>
      <tbody>
        <tr>
          <th class="bg-tbl-light">お客様送り先CD</th>
          <td colspan="2">
            <input
              type="text"
              class="form-control"
              v-model="searchClientdelivery_cd"
            />
          </td>
          <th class="bg-tbl-light">Nitto出荷先CD</th>
          <td colspan="2">
            <input
              type="text"
              class="form-control"
              v-model="searchDelivery_cd"
            />
          </td>
          <th class="bg-tbl-light">出荷先TEL</th>
          <td colspan="2">
            <input type="text" class="form-control" v-model="searchTel_no" />
          </td>
          <th class="bg-tbl-light">出荷先FAX</th>
          <td colspan="2">
            <input type="text" class="form-control" v-model="searchFax_no" />
          </td>
        </tr>
        <tr>
          <th class="bg-tbl-light">出荷先カナ</th>
          <td colspan="3">
            <input
              type="text"
              class="form-control"
              v-model="searchCompanyka_na"
            />
          </td>
          <th class="bg-tbl-light">出荷先名</th>
          <td colspan="3">
            <input
              type="text"
              class="form-control"
              v-model="searchCompany_na"
            />
          </td>
          <th class="bg-tbl-light">出荷先支店名</th>
          <td colspan="3">
            <input
              type="text"
              class="form-control"
              v-model="searchSubfactory_na"
            />
          </td>
        </tr>
      </tbody>
    </table>

    <div class="btn-center">
      <button
        type="button"
        @click="searchConvertDeliveryHandler"
        class="btn btn-order btn-lg"
      >
        検索
      </button>
    </div>

    <div v-if="searchErrorResponse.message" class="alert alert-danger mt-3">
      {{ searchErrorResponse.message }}
    </div>

    <template v-if="isSearchResult">
      <h2 class="hdg_order01 mt40"><i></i>変換送り先マスタ一覧</h2>
      <div class="mb-3 d-flex justify-content-end">
        <bs-pagination
          :page.sync="page"
          :per-page="per_page"
          :number="searchResultLength"
        ></bs-pagination>
      </div>
      <div class="table-responsive mb-4">
        <table class="table table-bordered bg-white data_table text-nowrap">
          <thead>
            <tr class="bg-tbl-head text-white text-center">
              <th></th>
              <th style="min-width: 10em">お客様CD</th>
              <th style="min-width: 10em">Nitto出荷先CD</th>
              <th style="min-width: 10em">出荷先カナ</th>
              <th style="min-width: 10em">出荷先名</th>
              <th style="min-width: 10em">出荷先支店名</th>
              <th style="min-width: 10em">出荷先担当者名</th>
              <th style="min-width: 10em">郵便番号</th>
              <th style="min-width: 10em">出荷先住所1</th>
              <th style="min-width: 10em">出荷先住所2</th>
              <th style="min-width: 10em">出荷先住所3</th>
              <th style="min-width: 10em">住所1ｶﾅ</th>
              <th style="min-width: 10em">住所2ｶﾅ</th>
              <th style="min-width: 10em">出荷先TEL</th>
              <th style="min-width: 10em">出荷先FAX</th>
            </tr>
          </thead>
          <tbody>
            <tr
              class="text-center"
              v-for="delivery in filteredsearchResults"
              :key="delivery.row_no"
            >
              <td>
                <button
                  class="btn btn-primary btn-sm"
                  @click="getConvertDeliveryInfoHandler(delivery)"
                >
                  選択
                </button>
              </td>
              <td>{{ delivery.clientdelivery_cd }}</td>
              <td>{{ delivery.delivery_cd }}</td>
              <td>{{ delivery.dlcompanyka_na }}</td>
              <td>{{ delivery.dlcompany_na }}</td>
              <td>{{ delivery.dlsubfactory_na }}</td>
              <td>{{ delivery.dluser_na }}</td>
              <td>{{ delivery.dlpost_no }}</td>
              <td>{{ delivery.dladdress1_na }}</td>
              <td>{{ delivery.dladdress2_na }}</td>
              <td>{{ delivery.dladdress3_na }}</td>
              <td>{{ delivery.dladdresskana1_na }}</td>
              <td>{{ delivery.dladdresskana2_na }}</td>
              <td>{{ delivery.dltel_no }}</td>
              <td>{{ delivery.dlfax_no }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>

    <template v-if="isDetailResult">
      <h2 id="detail" class="hdg_order01"><i></i>変換マスタ　詳細</h2>
      <table class="table table-bordered bg-white tbl_master02">
        <thead>
          <tr class="bg-tbl-head">
            <th>項目</th>
            <th>お客様データ</th>
            <th>日東側データ</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th class="bg-tbl-light">お客様送り先CD</th>
            <td>{{ convertItem.clientdelivery_cd }}</td>
            <td class="bg-tbl-blue">{{ convertItem.nd_delivery }}</td>
          </tr>
          <tr>
            <th class="bg-tbl-light">出荷先名</th>
            <td>{{ convertItem.dlcompany_na }}</td>
            <td class="bg-tbl-blue">{{ convertItem.nd_dlcompany_na }}</td>
          </tr>
          <tr>
            <th class="bg-tbl-light">支店名</th>
            <td>{{ convertItem.dlsubfactory_na }}</td>
            <td class="bg-tbl-blue">{{ convertItem.nd_dlsubfactory_na }}</td>
          </tr>
          <tr>
            <th class="bg-tbl-light">出荷先カナ</th>
            <td>{{ convertItem.dlcompanyka_na }}</td>
            <td class="bg-tbl-blue">{{ convertItem.nd_dlcompanyka_na }}</td>
          </tr>
          <tr>
            <th class="bg-tbl-light">出荷先担当者</th>
            <td>{{ convertItem.dluser_na }}</td>
            <td class="bg-tbl-blue">{{ convertItem.nd_dluser_na }}</td>
          </tr>
          <tr>
            <th class="bg-tbl-light">郵便番号</th>
            <td>{{ convertItem.dlpost_no }}</td>
            <td class="bg-tbl-blue">{{ convertItem.nd_dlpost_no }}</td>
          </tr>
          <tr>
            <th class="bg-tbl-light">住所１</th>
            <td>{{ convertItem.dladdress1_na }}</td>
            <td class="bg-tbl-blue">{{ convertItem.nd_dladdress1_na }}</td>
          </tr>
          <tr>
            <th class="bg-tbl-light">住所２</th>
            <td>{{ convertItem.dladdress2_na }}</td>
            <td class="bg-tbl-blue">{{ convertItem.nd_dladdress2_na }}</td>
          </tr>
          <tr>
            <th class="bg-tbl-light">住所３</th>
            <td>{{ convertItem.dladdress3_na }}</td>
            <td class="bg-tbl-blue">{{ convertItem.nd_dladdress3_na }}</td>
          </tr>
          <tr>
            <th class="bg-tbl-light">住所カナ１</th>
            <td>{{ convertItem.dladdresskana1_na }}</td>
            <td class="bg-tbl-blue">{{ convertItem.nd_dladdresskana1_na }}</td>
          </tr>
          <tr>
            <th class="bg-tbl-light">住所カナ２</th>
            <td>{{ convertItem.dladdresskana2_na }}</td>
            <td class="bg-tbl-blue">{{ convertItem.nd_dladdresskana2_na }}</td>
          </tr>
          <tr>
            <th class="bg-tbl-light">TEL</th>
            <td>{{ convertItem.dltel_no }}</td>
            <td class="bg-tbl-blue">{{ convertItem.nd_dltel_no }}</td>
          </tr>
          <tr>
            <th class="bg-tbl-light">FAX</th>
            <td>{{ convertItem.dlfax_no }}</td>
            <td class="bg-tbl-blue">{{ convertItem.nd_dlfax_no }}</td>
          </tr>
        </tbody>
      </table>
    </template>
  </section>
</template>

<script>
import {
  // store as loginUser,
  mutations as loginUserMutations
} from "../../../../store/LoginUser";

export default {
  data() {
    return {
      // Search Field
      searchClientdelivery_cd: "",
      searchCompany_na: "",
      searchSubfactory_na: "",
      searchTel_no: "",
      searchFax_no: "",
      searchCompanyka_na: "",
      searchDelivery_cd: "",
      // searchAddress_na: "",

      // Result
      isSearchResult: false,
      searchErrorResponse: {},
      convertDeliveryList: [],

      page: 1,
      per_page: 10,

      isDetailResult: false,
      detailErrorResponse: {},
      convertItem: null
    };
  },
  computed: {
    searchResultLength() {
      return this.convertDeliveryList.length;
    },
    filteredsearchResults() {
      const from = (this.page - 1) * this.per_page;
      const to = from + this.per_page;
      return this.convertDeliveryList.slice(from, to);
    }
  },
  async beforeMount() {
    const response = await this.getInitDataHandler();
    if (response.responseData.return != "0") {
      this.redirectToLogin();
      return;
    }

    // Set Login User Info
    loginUserMutations.setUserInfo(
      this.getAsteriaFirst(response.responseData, "loginUserInfoData")
    );
  },
  methods: {
    /**
     * Get initial data from ASTERIA
     */
    async getInitDataHandler() {
      const response = await this.postAsteria("FileOrder", "getInitData");

      return response;
    },

    async searchConvertDeliveryHandler() {
      this.page = 1;
      this.isSearchResult = false;
      this.isDetailResult = false;
      this.searchErrorResponse = {};

      const response = await this.postAsteria(
        "FileOrder",
        "searchConvertDelivery",
        {
          searchClientdelivery_cd: this.searchClientdelivery_cd,
          searchCompany_na: this.searchCompany_na,
          searchSubfactory_na: this.searchSubfactory_na,
          searchTel_no: this.searchTel_no,
          searchFax_no: this.searchFax_no,
          searchCompanyka_na: this.searchCompanyka_na,
          searchDelivery_cd: this.searchDelivery_cd
          // searchAddress_na: this.searchAddress_na
        }
      );

      if (response.responseData.return != 0) {
        this.searchErrorResponse = response.responseData;
        // window.alert("出荷先変換マスタの検索に失敗しました");
        return;
      }

      this.isSearchResult = true;
      this.convertDeliveryList = this.getAsteriaArray(
        response.responseData,
        "convertDeliveryList"
      );
      return response;
    },
    async getConvertDeliveryInfoHandler(delivery) {
      this.isDetailResult = false;
      this.detailErrorResponse = {};

      const response = await this.postAsteria(
        "FileOrder",
        "getConvertDeliveryInfo",
        {
          searchDelivery_cd: delivery.delivery_cd || "",
          searchClientdelivery_cd: delivery.clientdelivery_cd || "",
          searchCompanyka_na: delivery.dlcompanyka_na || "",
          searchCompany_na: delivery.dlcompany_na || "",
          searchSubfactory_na: delivery.dlsubfactory_na || ""
        }
      );

      if (response.responseData.return != 0) {
        // window.alert("変換マスタ詳細の取得に失敗しました");
        window.alert(response.responseData.message);
        return;
      }

      this.isDetailResult = true;
      this.convertItem = this.getAsteriaFirst(
        response.responseData,
        "convertDelivery"
      );

      this.$nextTick(() => {
        const target = document.querySelector("#detail");

        // target.scrollIntoView({
        //   behavior: "smooth",
        //   block: "center"
        // });
        this.$perfectScrollbar.scrollTo(target);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
table[data-scoped] {
  th {
    width: 10%;
  }
  td {
    width: 7%;

    &[colspan="2"] {
      width: 14%;
    }
    &[colspan="3"] {
      width: 21%;
    }
  }
}
</style>
